import { Card, Skeleton, Stack } from "@mui/material";

export default function AboutSekeleton() {
    return (
        <Card className="pagelist-content" style={{ padding: "15px" }}>
            <Stack sx={{ mb: 2,  justifyContent: "space-between", alignItems: "center" }} direction="row" >
                <Skeleton variant="text" width={100} height={32} />
                <Skeleton variant="rectangular" width={80} height={36} />
            </Stack>
            {/* Email */}
            <Stack direction="row" sx={{ mb: 2, alignItems: "center", width: "100%" }} spacing={2} >
                <Skeleton variant="circular" width={32} height={32} />
                <Stack sx={{ width: "100%" }}>
                    <Skeleton variant="text" width="60%" height={24} />
                    <Skeleton variant="text" width="30%" height={18} />
                </Stack>
                <Skeleton variant="circular" width={20} height={20} />
            </Stack>
            {/* Phone */}
            <Stack direction="row" sx={{ mb: 2, alignItems: "center", width: "100%" }} spacing={2} >
                <Skeleton variant="circular" width={32} height={32} />
                <Stack sx={{ width: "100%" }}>
                    <Skeleton variant="text" width="50%" height={24} />
                    <Skeleton variant="text" width="25%" height={18} />
                </Stack>
                <Skeleton variant="circular" width={20} height={20} />
            </Stack>
            {/* Address */}
            <Stack direction="row" sx={{ mb: 2, alignItems: "center", width: "100%" }} spacing={2} >
                <Skeleton variant="circular" width={32} height={32} />
                <Stack sx={{ width: "100%" }}>
                    <Skeleton variant="text" width="80%" height={24} />
                </Stack>
            </Stack>
        </Card>
    )
}
